import { Customer, UserInfo, DashboardData, DashboardDataResponseDTO } from '../entities';

const dashboardDataResponseDTOtoDashboardDataAdapter = (response: DashboardDataResponseDTO): DashboardData => {
  if (!response.body) {
    throw Error();
  }

  const { userInfo, companies } = response.body;
  if (!companies.length) {
    throw new Error('Selected user has no companies linked under their profile!');
  }
  const customers = companies.map(
    ({ customerId, customerType, description, email, phoneNumber, website }) =>
      new Customer(customerId, customerType, description, email, phoneNumber, website),
  );
  const userInformation = new UserInfo(
    userInfo.username,
    userInfo.firstname,
    userInfo.lastname,
    userInfo.email,
    userInfo.hashedEmail,
    userInfo.lastLogin,
    userInfo.phoneNumber,
    userInfo.customerType,
    userInfo.omniUserId,
    userInfo.customerId,
  );

  return new DashboardData(userInformation, customers);
};

export { dashboardDataResponseDTOtoDashboardDataAdapter };
